import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const CloseFill: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#666', style }) => (
  /*@ts-ignore*/
  <svg color="inherit" viewBox="0 0 24 24" width={width} height={height} style={style}>
    {/*@ts-ignore*/}
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      {/*@ts-ignore*/}
      <g id="icon-cancel">
        <path
          d="M12,10.5857864 L9.17157288,7.75735931 C8.78104858,7.36683502 8.1478836,7.36683502 7.75735931,7.75735931 C7.36683502,8.1478836 7.36683502,8.78104858 7.75735931,9.17157288 L10.5857864,12 L7.75735931,14.8284271 C7.36683502,15.2189514 7.36683502,15.8521164 7.75735931,16.2426407 C8.1478836,16.633165 8.78104858,16.633165 9.17157288,16.2426407 L12,13.4142136 L14.8284271,16.2426407 C15.2189514,16.633165 15.8521164,16.633165 16.2426407,16.2426407 C16.633165,15.8521164 16.633165,15.2189514 16.2426407,14.8284271 L13.4142136,12 L16.2426407,9.17157288 C16.633165,8.78104858 16.633165,8.1478836 16.2426407,7.75735931 C15.8521164,7.36683502 15.2189514,7.36683502 14.8284271,7.75735931 L12,10.5857864 Z M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z"
          fill={fill}
        />
        <polygon points="0 0 24 0 24 24 0 24" />
      </g>
    </g>
  </svg>
);

export default CloseFill;
